import path from 'path';
import { RotateFlags } from './openCVProperties';

const { app } = require('electron').remote;
// throws error as it would be packed into main.js where this is can not be required
// tried it again and it seems to work, lets see

export const URL_CHANGE_LOG = 'https://movieprint.org/download/';
export const URL_REST_API_CHECK_FOR_UPDATES = 'https://movieprint.org/wp-json/wp/v2/pages/114'; // _Latest_Release page
export const URL_FEEDBACK_FORM = 'http://movieprint.org/contact-us-from-movieprint-app';

export const SHOT_DETECTION_METHOD = {
  MEAN: 'meanAverage',
  HIST: 'histogram',
};

export const THUMB_SELECTION = {
  ALL_THUMBS: 'allThumbs',
  VISIBLE_THUMBS: 'visibleThumbs',
  HIDDEN_THUMBS: 'hiddenThumbs',
};

export const SHOT_DETECTION_METHOD_OPTIONS = [
  { value: SHOT_DETECTION_METHOD.MEAN, text: 'Mean average', 'data-tid': 'shotDetectionMethodOptionsMean' },
  { value: SHOT_DETECTION_METHOD.HIST, text: 'Histogram', 'data-tid': 'shotDetectionMethodOptionsHist' },
];

export const OUTPUT_FORMAT = {
  PNG: 'png',
  JPG: 'jpg',
};

export const MOVIEPRINT_WIDTH_HEIGHT_SIZE_LIMIT = 16384; // due to browser limitations https://html2canvas.hertzen.com/faq

export const MOVIEPRINT_WIDTH_HEIGHT = [
  1024,
  2048,
  3072,
  4096,
  5120,
  6144,
  7168,
  8192,
  9216,
  10240,
  11264,
  12288,
  13312,
  14336,
  15360,
  16384,
];

export const SCALE_VALUE_ARRAY = [0.25, 0.33, 0.5, 0.75, 1, 2, 3, 4, 5, 6, 7, 8];

export const COLOR_PALETTE_PICO_EIGHT = [
  'transparent',
  '#000000',
  '#FFFFFF',
  '#0C0C0C',
  '#1E1E1E',
  '#FF5006',
  '#FF9365',
  '#B44E23',
  '#D14003',
  '#1D2B53',
  '#7E2553',
  '#008751',
  '#AB5236',
  '#5F574F',
  '#C2C3C7',
  '#FFF1E8',
  '#FF004D',
  '#FFA300',
  '#FFEC27',
  '#00E436',
  '#29ADFF',
  '#83769C',
  '#FF77A8',
  '#FFCCAA',
];

export const FRAMEINFO_POSITION = {
  TOPLEFT: 'topLeft',
  TOPCENTER: 'topCenter',
  TOPRIGHT: 'topRight',
  CENTERCENTER: 'centerCenter',
  BOTTOMLEFT: 'bottomLeft',
  BOTTOMCENTER: 'bottomCenter',
  BOTTOMRIGHT: 'bottomRight',
};

export const FRAMEINFO_POSITION_OPTIONS = [
  { value: FRAMEINFO_POSITION.TOPLEFT, text: 'Top Left', 'data-tid': 'frameinfoPositionOptionTopLeft' },
  { value: FRAMEINFO_POSITION.TOPCENTER, text: 'Top Center', 'data-tid': 'frameinfoPositionOptionTopCenter' },
  { value: FRAMEINFO_POSITION.TOPRIGHT, text: 'Top Right', 'data-tid': 'frameinfoPositionOptionTopRight' },
  { value: FRAMEINFO_POSITION.CENTERCENTER, text: 'Center Center', 'data-tid': 'frameinfoPositionOptionCenterCenter' },
  { value: FRAMEINFO_POSITION.BOTTOMLEFT, text: 'Bottom Left', 'data-tid': 'frameinfoPositionOptionBottomLeft' },
  { value: FRAMEINFO_POSITION.BOTTOMCENTER, text: 'Bottom Center', 'data-tid': 'frameinfoPositionOptionBottomCenter' },
  { value: FRAMEINFO_POSITION.BOTTOMRIGHT, text: 'Bottom Right', 'data-tid': 'frameinfoPositionOptionBottomRight' },
];

export const SHEET_FIT = {
  WIDTH: 'width',
  HEIGHT: 'height',
  BOTH: 'both',
  NOSCALE: 'noScale',
};

export const SHEET_TYPE = {
  INTERVAL: 'interval',
  SCENES: 'shot',
  FACES: 'faces',
};

export const SHEET_TYPE_OPTIONS = [
  { value: SHEET_TYPE.INTERVAL, text: 'Interval', 'data-tid': 'sheetTypeOptionsInterval' },
  { value: SHEET_TYPE.SCENES, text: 'Scenes', 'data-tid': 'sheetTypeOptionsScenes' },
  { value: SHEET_TYPE.FACES, text: 'Faces', 'data-tid': 'sheetTypeOptionsFaces' },
];

export const THUMB_INFO = {
  FRAMES: 'frames',
  TIMECODE: 'timecode',
  HIDEINFO: 'hideInfo',
};

export const THUMB_INFO_OPTIONS = [
  { value: THUMB_INFO.FRAMES, text: 'Show frames', 'data-tid': 'framesOption' },
  { value: THUMB_INFO.TIMECODE, text: 'Show timecode', 'data-tid': 'timecodeOption' },
  { value: THUMB_INFO.HIDEINFO, text: 'Hide info', 'data-tid': 'hideInfoOption' },
];

export const SHEET_VIEW = {
  GRIDVIEW: 'gridView',
  TIMELINEVIEW: 'timelineView',
};

export const VIEW = {
  PLAYERVIEW: 'playerView',
  STANDARDVIEW: 'standardView',
};

export const MOVIEPRINT_COLORS = ['#FF5006', '#FFb799', '#FF9365', '#FFa883', '#FFd3c1'];

export const PAPER_LAYOUT_OPTIONS = [
  { value: 0.71, text: 'A0-A5 (Landscape)', 'data-tid': 'A0-A5-L' },
  { value: 1.41, text: 'A0-A5 (Portrait)', 'data-tid': 'A0-A5-P' },
  { value: 0.77, text: 'Letter (Landscape)', 'data-tid': 'Letter-L' },
  { value: 1.29, text: 'Letter (Portrait)', 'data-tid': 'Letter-P' },
  { value: 0.61, text: 'Legal (Landscape)', 'data-tid': 'Legal-L' },
  { value: 1.65, text: 'Legal (Portrait)', 'data-tid': 'Legal-P' },
  { value: 0.65, text: 'Tabloid (Landscape)', 'data-tid': 'Tabloid-L' },
  { value: 1.55, text: 'Tabloid (Portrait)', 'data-tid': 'Tabloid-P' },
  { value: 1.0, text: 'Square', 'data-tid': 'Square' },
  { value: 0.75, text: '4:3', 'data-tid': '4:3' },
  { value: 0.625, text: '16:10', 'data-tid': '16:10' },
  { value: 0.5625, text: '16:9', 'data-tid': '16:9' },
  { value: 0.5, text: '2:1', 'data-tid': '2:1' },
  { value: 1.778, text: '9:16', 'data-tid': '9:16' },
  { value: 2.0, text: '1:2', 'data-tid': '1:2' },
];

export const OUTPUT_FORMAT_OPTIONS = [
  { value: OUTPUT_FORMAT.PNG, text: 'PNG', 'data-tid': 'pngOption' },
  { value: OUTPUT_FORMAT.JPG, text: 'JPG', 'data-tid': 'jpgOption' },
];

export const EXPORT_FORMAT_OPTIONS = {
  JSON: 'json',
  EDL: 'edl',
};

export const CACHED_FRAMES_SIZE_OPTIONS = [
  { value: 0, text: 'Original size', 'data-tid': 'originalSizeOption' }, // 0 stands for original size
  { value: 80, text: '80px', 'data-tid': '80option' },
  { value: 160, text: '160px', 'data-tid': '160option' },
  { value: 320, text: '320px', 'data-tid': '320option' },
  { value: 640, text: '640px', 'data-tid': '640option' },
  { value: 720, text: '720px', 'data-tid': '720option' },
];

// start initialStateJSON
export const VISIBILITY_FILTER = THUMB_SELECTION.VISIBLE_THUMBS;
export const SHOW_MOVIELIST = false;
export const SHOW_SETTINGS = false;
export const DEFAULT_VIEW = VIEW.STANDARDVIEW;
export const DEFAULT_SHEETVIEW = SHEET_VIEW.GRIDVIEW;
export const DEFAULT_SHEET_TYPE = SHEET_TYPE.INTERVAL;
export const DEFAULT_SHEET_FIT = SHEET_FIT.BOTH;

export const DEFAULT_THUMB_COUNT_MAX = 10000;
export const DEFAULT_THUMB_COUNT = 16;
export const DEFAULT_COLUMN_COUNT = 4;
export const DEFAULT_THUMBNAIL_SCALE = 0.25;
export const DEFAULT_MOVIEPRINT_WIDTH = 4096;
export const DEFAULT_MARGIN_RATIO = 0.02;
export const DEFAULT_MARGIN_SLIDER_FACTOR = 200.0;
export const DEFAULT_BORDER_RADIUS_RATIO = 0.04;
export const DEFAULT_HEADER_HEIGHT_RATIO = 0.25;
export const DEFAULT_SHOW_HEADER = false;
export const DEFAULT_SHOW_PATH_IN_HEADER = true;
export const DEFAULT_SHOW_DETAILS_IN_HEADER = true;
export const DEFAULT_SHOW_TIMELINE_IN_HEADER = true;
export const DEFAULT_ROUNDED_CORNERS = true;
export const DEFAULT_THUMB_INFO = 'hideInfo';
export const DEFAULT_THUMB_INFO_RATIO = 0.075;
// export const DEFAULT_OUTPUT_PATH = app.getPath('desktop'); // throws error see above
export const DEFAULT_OUTPUT_PATH_FROM_MOVIE = false;
export const DEFAULT_OUTPUT_FORMAT = OUTPUT_FORMAT.PNG;
export const DEFAULT_OUTPUT_JPG_QUALITY = 80;
export const DEFAULT_THUMB_FORMAT = OUTPUT_FORMAT.JPG;
export const DEFAULT_THUMB_JPG_QUALITY = 95;
export const DEFAULT_SAVE_OPTION_OVERWRITE = false;
export const DEFAULT_SAVE_OPTION_INCLUDE_INDIVIDUAL = false;
export const DEFAULT_VIDEO_PLAYER_HEIGHT = 360;
export const DEFAULT_VIDEO_PLAYER_WIDTH = 640;
export const DEFAULT_VIDEO_PLAYER_CONTROLLER_HEIGHT = 84;
export const DEFAULT_BORDER_MARGIN = 24;
export const DEFAULT_SHOW_PAPER_PREVIEW = false;
export const DEFAULT_PAPER_ASPECTRATIOINV = 0.71;
export const DEFAULT_DETECT_INOUTPOINT = false;
export const DEFAULT_SCRUB_CONTAINER_MAXHEIGHTRATIO = 0.8;
export const DEFAULT_SCRUB_WINDOW_WIDTHRATIO = 0.5;
export const DEFAULT_SCRUB_WINDOW_HEIGHTRATIO = 0.5;
export const DEFAULT_SCRUB_WINDOW_MARGIN = 2;
export const DEFAULT_SCENE_DETECTION_THRESHOLD = 6.0;
export const DEFAULT_TIMELINEVIEW_SECONDS_PER_ROW = 120.0;
export const DEFAULT_TIMELINEVIEW_MIN_DISPLAY_SCENE_LENGTH_IN_FRAMES = 10;
export const DEFAULT_TIMELINEVIEW_WIDTH_SCALE = 50;
export const DEFAULT_TIMELINEVIEW_FLOW = false;
export const DEFAULT_CACHED_FRAMES_SIZE = 640; // 0 stands for original size
export const DEFAULT_EMBED_FRAMENUMBERS = true;
export const DEFAULT_EMBED_FILEPATH = true;
export const DEFAULT_SHOW_IMAGES = true;
export const DEFAULT_MOVIEPRINT_BACKGROUND_COLOR = { r: 0, g: 0, b: 0, a: 0 };
export const DEFAULT_FRAMEINFO_BACKGROUND_COLOR = { r: 238, g: 238, b: 238, a: 1 };
export const DEFAULT_FRAMEINFO_COLOR = { r: 0, g: 0, b: 0, a: 1 };
export const DEFAULT_FRAMEINFO_POSITION = FRAMEINFO_POSITION.TOPLEFT;
export const DEFAULT_FRAMEINFO_SCALE = 10.0;
export const DEFAULT_FRAMEINFO_MARGIN = 0;
export const DEFAULT_MOVIEPRINT_NAME = '[MN].[ME]-[MPN]';
export const DEFAULT_SINGLETHUMB_NAME = '[MN].[ME]-frame[FN]';
export const DEFAULT_ALLTHUMBS_NAME = '[MN].[ME]-[FN]';
export const DEFAULT_OPEN_FILE_EXPLORER_AFTER_SAVING = false;
export const DEFAULT_SHOW_FACERECT = true;
// end initialStateJSON

// fallback window measures
export const WINDOW_WIDTH = 1366; // main window width and height is set in main.dev.js
export const WINDOW_HEIGHT = 768;

export const MENU_HEADER_HEIGHT = 35;
export const MENU_FOOTER_HEIGHT = 35;

export const ZOOM_SCALE = 4; // index of SCALE_VALUE_ARRAY
export const PAPER_ADJUSTMENT_SCALE = 0.9;
export const MARGIN_ADJUSTMENT_SCALE = 0.95;

export const DEFAULT_MOVIE_WIDTH = 1920;
export const DEFAULT_MOVIE_HEIGHT = 1080;
export const DEFAULT_MOVIE_ASPECTRATIO = 1.778;

// fixes jumping of thumbs due to hoverButton by giving the moviePrint some extra space around
// should be 0 for printing
export const DEFAULT_MIN_MOVIEPRINTWIDTH_MARGIN = 10;

export const MINIMUM_WIDTH_TO_SHRINK_HOVER = 160; // if smaller then scale hover to 0.7
export const MINIMUM_WIDTH_TO_SHOW_HOVER = 100; // if smaller then do not show hover elements over thumb

export const CHANGE_THUMB_STEP = [1, 10, 100];

export const IN_OUT_POINT_SEARCH_LENGTH = 300;
export const IN_OUT_POINT_SEARCH_THRESHOLD = 20; // previous 15

export const SCENE_DETECTION_MIN_SCENE_LENGTH = 10; // for scene detection

export const DEFAULT_FRAME_SCALE = 1; // scale of frames to be stored in the database if 1 then original size is stored

export const FRAMESDB_PATH = path.join(app.getPath('userData'), 'moviePrint_frames.db');

export const STATEID = '1';

export const SCRUBCUT_SLICE_ARRAY_SIZE = 19;

// videoPlayer
export const VIDEOPLAYER_SLICEGAP = 1;
export const VIDEOPLAYER_CUTGAP = 8;
export const VIDEOPLAYER_SLICE_ARRAY_SIZE = 20;
export const VIDEOPLAYER_SCENE_MARGIN = 4;
export const VIDEOPLAYER_THUMB_MARGIN = 4;
export const VIDEOPLAYER_FIXED_PIXEL_PER_FRAME_RATIO = 0.3;

export const TIMELINE_SCENE_MINIMUM_WIDTH = 2; // heightOfInOutPointButtons
export const TIMELINE_PLAYHEAD_MINIMUM_WIDTH = 2;

// face detection
export const FACE_SIZE_THRESHOLD = 10; // faces smaller than this percentage of the movie height are ignored
export const FACE_CONFIDENCE_THRESHOLD = 70; // detected faces with a lower score are ignored
export const FACE_UNIQUENESS_THRESHOLD = 0.6; // faces with a euclideanDistance larger than this are considered unique
export const SORT_METHOD = {
  AGE: 'age',
  DISTTOORIGIN: 'distToOrigin',
  FACECONFIDENCE: 'score',
  FACECOUNT: 'faceCount',
  FACEOCCURRENCE: 'faceOccurrence',
  FACESIZE: 'size',
  FRAMENUMBER: 'frameNumber',
  GENDER: 'gender',
  REVERSE: 'reverse',
};
export const SORT_METHOD_OPTIONS = [
  { value: SORT_METHOD.FRAMENUMBER, text: 'framenumber', 'data-tid': 'sortMethodOptionsFrameNumber' },
  { value: SORT_METHOD.FACESIZE, text: 'size of face', 'data-tid': 'sortMethodOptionsFaceSize' },
  { value: SORT_METHOD.FACECOUNT, text: 'number of faces', 'data-tid': 'sortMethodOptionsFaceCount' },
  { value: SORT_METHOD.FACEOCCURRENCE, text: 'occurrence of face', 'data-tid': 'sortMethodOptionsFaceOccurrence' },
  { value: SORT_METHOD.DISTTOORIGIN, text: 'distance to origin', 'data-tid': 'sortMethodOptionsDistToOrigin' },
  { value: SORT_METHOD.FACECONFIDENCE, text: 'confidence of face', 'data-tid': 'sortMethodOptionsFaceConfidence' },
  { value: SORT_METHOD.REVERSE, text: 'reverse order', 'data-tid': 'sortMethodOptionsReverse' },
];
export const FILTER_METHOD = {
  AGE: 'age', // range
  DISTTOORIGIN: 'distToOrigin', // equals/range
  FACECONFIDENCE: 'score', // range
  FACECOUNT: 'faceCount', // range
  FACEID: 'faceId', // equals array
  FACEOCCURRENCE: 'faceOccurrence', // range
  FACESIZE: 'size', // range
  GENDER: 'gender', // equals
};
export const FILTER_METHOD_AGE = {
  MIN: 0,
  LOWER: 20,
  UPPER: 40,
  MAX: 100, // slider max value
  MAXMAX: 200, // max value when filtering to not exclude top values
};
export const FILTER_METHOD_FACECOUNT = {
  MIN: 1,
  LOWER: 1,
  UPPER: 3,
  MAX: 10, // slider max value
  MAXMAX: 100, // max value when filtering to not exclude top values
};
export const FILTER_METHOD_FACEOCCURRENCE = {
  MIN: 1,
  LOWER: 10,
  UPPER: 100,
  MAX: 100, // slider max value
  MAXMAX: 10000, // max value when filtering to not exclude top values
};
export const FILTER_METHOD_FACESIZE = {
  // MIN: 1, // no MIN value -> handled by defaultFaceSizeThreshold
  LOWER: 50,
  UPPER: 100,
  MEDIUM: 30,
  CLOSE: 75,
  MAX: 100, // slider max value
  MAXMAX: 1000, // max value when filtering to not exclude top values
};

// app settings
export const UNDO_STEPS_LIMIT = 50; // undo redo

// edit transform
export const TRANSFORMOBJECT_INIT = {
  cropTop: 0,
  cropLeft: 0,
  cropBottom: 0,
  cropRight: 0,
  rotationFlag: RotateFlags.NO_ROTATION,
  aspectRatioInv: null,
};

export const EDIT_TRANSFORM_CANVAS_WIDTH = 480;
export const EDIT_TRANSFORM_CANVAS_HEIGHT = 480;

export const ROTATION_OPTIONS = [
  { value: RotateFlags.NO_ROTATION, text: 'No rotation', 'data-tid': 'rotationOptions0' },
  { value: RotateFlags.ROTATE_90_CLOCKWISE, text: '90º clockwise', 'data-tid': 'rotationOptions90' },
  { value: RotateFlags.ROTATE_180, text: '180º', 'data-tid': 'rotationOptions180' },
  {
    value: RotateFlags.ROTATE_90_COUNTERCLOCKWISE,
    text: '90º counterclockwise',
    'data-tid': 'rotationOptions270',
  },
];

export const ASPECT_RATIO_OPTIONS = [
  { value: null, text: 'Reset', 'data-tid': 'Reset' },
  { value: 0.5625, text: '16:9', 'data-tid': '16:9' },
  { value: 0.75, text: '4:3', 'data-tid': '4:3' },
  { value: 1.0, text: '1:1', 'data-tid': '1:1' },
  { value: 0.625, text: '16:10', 'data-tid': '16:10' },
  { value: 0.5405, text: '1.85:1', 'data-tid': '1.85:1' },
  { value: 0.5525, text: '2.21:1', 'data-tid': '2.21:1' },
  { value: 0.4255, text: '2.35:1', 'data-tid': '2.35:1' },
  { value: 0.4184, text: '2.39:1', 'data-tid': '2.39:1' },
  { value: 0.6, text: '5:3', 'data-tid': '5:3' },
  { value: 0.8, text: '5:4', 'data-tid': '5:4' },
];

export const CROP_OPTIONS = [
  { value: null, text: 'Reset', 'data-tid': 'Reset' },
  { value: 0.625, text: '16:10', 'data-tid': '16:10' },
  { value: 0.5625, text: '16:9', 'data-tid': '16:9' },
  { value: 0.75, text: '4:3', 'data-tid': '4:3' },
  { value: 0.5405, text: '1.85:1', 'data-tid': '1.85:1' },
  { value: 0.5525, text: '2.21:1', 'data-tid': '2.21:1' },
  { value: 0.4255, text: '2.35:1', 'data-tid': '2.35:1' },
  { value: 0.4184, text: '2.39:1', 'data-tid': '2.39:1' },
  { value: 0.5, text: '2:1', 'data-tid': '2:1' },
  { value: 0.6, text: '5:3', 'data-tid': '5:3' },
  { value: 0.8, text: '5:4', 'data-tid': '5:4' },
  { value: 1.0, text: '1:1', 'data-tid': '1:1' },
  { value: 1.25, text: '4:5', 'data-tid': '4:5' },
  { value: 1.5, text: '2:3', 'data-tid': '2:3' },
  { value: 1.7778, text: '9:16', 'data-tid': '9:16' },
];
